import { Avatar } from "@shared/ui";
import { Instagram, Youtube } from "lucide-react";
import React from "react";
import styles from "./styles.module.scss";

interface CreatorInfoProps {
  name?: string;
  username: string;
  link?: string;
  platform?: string;
  profilePicUrl?: string;
  campaignName?: string;
  statusTag?: React.ReactNode;
}

export function CreatorInfo({
  name,
  username,
  link,
  platform,
  profilePicUrl,
  campaignName,
  statusTag,
}: CreatorInfoProps) {
  const platformLower = platform?.toLowerCase();

  return (
    <div className={styles.creatorInfo}>
      <div className={styles.avatarContainer}>
        <Avatar
          size={35}
          src={profilePicUrl}
          className={styles.avatar}
          style={{ flexShrink: 0 }}
        >
          {name?.[0] || username?.[0] || "C"}
        </Avatar>
        {platformLower && (
          <div className={styles.platformBadge}>
            {platformLower === "instagram" ? (
              <Instagram size={10} className={styles.platformIconInstagram} />
            ) : platformLower === "youtube" ? (
              <Youtube size={10} className={styles.platformIconYoutube} />
            ) : platformLower === "tiktok" ? (
              <div className={styles.tiktokBadge}>Tk</div>
            ) : null}
          </div>
        )}
      </div>
      <div className={styles.creatorMeta}>
        <div className={styles.creatorNameRow}>
          <h3 className={styles.creatorName}>{name || "Creator"}</h3>
          {statusTag}
        </div>
        {(username || campaignName) && (
          <div className={styles.creatorDetails}>
            {username && (
              <>
                {link ? (
                  <a
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.creatorHandle}
                  >
                    @{username}
                  </a>
                ) : (
                  <span className={styles.creatorHandle}>@{username}</span>
                )}
                {campaignName && (
                  <>
                    <span className={styles.separator}>•</span>
                    <span className={styles.campaignName}>{campaignName}</span>
                  </>
                )}
              </>
            )}
            {!username && campaignName && (
              <span className={styles.campaignName}>{campaignName}</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
